import {
    useTheme,
    Box,
} from '@mui/material';
import { PROJECT_NAME } from '../../config';

const Introduction = () => {
    const theme = useTheme();
    return (
        <>
            <Box 
                sx={{ 
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column'
                }}
               
                minHeight='50vh'
            >
                <Box 
                    className="noselect h1-style"
                    sx={{ 
                        fontFamily: 'Emblema One', 
                        color: theme.palette.text.main, 
                        fontSize: '5rem',
                    }}
                >
                    {PROJECT_NAME}
                </Box>
                <Box>
                    <h1 className="h2-style">
                        Advanced URL shortener with numerous exceptional features
                    </h1>
                </Box>
            </Box>
        </>
    );
}

export default Introduction;